import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MessageRole } from '../../../domain/enums/message-role.enum';
import { ChatMessage } from '../../../domain/models/chat-message.model';

@Component({
  selector: 'talk-to-your-data-message-item',
  templateUrl: './message-item.component.html',
  styleUrls: ['./message-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageItemComponent {
  readonly messageRole = MessageRole;

  @Input() message!: ChatMessage;
  liked = false;

  disliked = false;

  onLike(): void {
    this.liked = !this.liked;

    if (this.liked) {
      this.disliked = false;
    }
  }

  onDislike(): void {
    this.disliked = !this.disliked;

    if (this.disliked) {
      this.liked = false;
    }
  }

  onCopy(): void {
    console.log('MESSAGE', this.message);

    console.log('BLOCKS', this.message?.blocks);
    const textToCopy = this.getMessageText();
    console.log('TEXT TO COPY', textToCopy);

    if (!textToCopy) {
      return;
    }

    navigator.clipboard.writeText(textToCopy);
  }

  private getMessageText(): string {
    if (!this.message?.blocks?.length) {
      return '';
    }

    return this.message.blocks
      .map((block) => {
        const content = (block as any).content || (block as any).text;

        if (typeof content === 'string') {
          return content;
        }

        return '';
      })
      .filter(Boolean)
      .join('\n');
  }
}
